<template>
  <div class="container">
    <template v-if="showType == 2">
    <van-popup v-model="showPopup" round position="bottom" :close-on-click-overlay="false" :style="{ height: '75%' }" @closed="questionnairePopupClosed">
      <div class="questionnaireBox">
        <div class="questionnaireTitle">
          <span class="title van-ellipsis">{{ title }}</span>
          <div class="close" @click="closeQuestion">
            <van-icon name="cross" />
          </div>
        </div>
        <div class="questionnaireContent">
          <div class="questionnaireItem" v-for="(item, index) in questionList" :key="item.Id" :ref="'questionRef_' + item.Id">
            <div class="question">
              <span class="questionType" v-if="item.type != 3">{{item.type == 1 ? '单选' : '多选'}}</span>
              <span class="questionText">{{index + 1}}.{{ item.title }}</span>
            </div>
            <div class="questionOptions" v-if="item.type != 3">
              <div class="option" :class="{'active': item.selectId.includes(option.Id)}" v-for="option in item.options" :key="option.Id" @click="selectOption(index, item.type, option.Id)">{{option.label}}<span v-if="option.label">. </span>{{ option.value }}</div>
            </div>
            <div class="textarea" v-else>
              <van-field
                :value="item.answer"
                @input="(val) => updateAnswer(index, val)"
                rows="2"
                autosize
                maxlength="20"
                show-word-limit
                type="textarea"
                placeholder="请输入"
              />
            </div>
            <div class="tips" v-if="isSubmit && ((item.type != 3 && item.selectId.length == 0) || (item.type == 3 && item.answer == ''))"><van-icon class="icon" name="warning-o" /><span>{{ item.type != 3 ? '请完成选择' : '请完成回答' }}</span></div>
          </div>
          <div class="submit" @click="submit">提交</div>
        </div>
      </div>
    </van-popup>
    </template>

    <template v-else>
      <div class="questionnaireBox">
        <div class="questionnaireTitle">
          <img class="arrow-left" src="@/assets/images/arrow-left.png" @click="goback" />
          <span class="title van-ellipsis">{{ title }}</span>
        </div>
        <div class="questionnaireContent">
          <div class="questionnaireItem" v-for="(item, index) in questionList" :key="item.Id" :ref="'questionRef_' + item.Id">
            <div class="question">
              <span class="questionType" v-if="item.type != 3">{{item.type == 1 ? '单选' : '多选'}}</span>
              <span class="questionText">{{index + 1}}.{{ item.title }}</span>
            </div>
            <div class="questionOptions" v-if="item.type != 3">
              <div class="option" :class="{'active': item.selectId.includes(option.Id)}" v-for="option in item.options" :key="option.Id" @click="selectOption(index, item.type, option.Id)">{{option.label}}<span v-if="option.label">. </span>{{ option.value }}</div>
            </div>
            <div class="textarea" v-else>
              <van-field
                :value="item.answer"
                @input="(val) => updateAnswer(index, val)"
                rows="2"
                autosize
                maxlength="20"
                show-word-limit
                type="textarea"
                placeholder="请输入"
              />
            </div>
            <div class="tips" v-if="isSubmit && ((item.type != 3 && item.selectId.length == 0) || (item.type == 3 && item.answer == ''))"><van-icon class="icon" name="warning-o" /><span>{{ item.type != 3 ? '请完成选择' : '请完成回答' }}</span></div>
          </div>
          <div class="submit" @click="submit">提交</div>
        </div>
      </div>
    </template>

    <van-popup class="toastPopup" v-model="showToast" round :close-on-click-overlay="false">
      <div class="toastBox">
        <img class="successIcon" src="@/assets/images/successIcon.png" />
        <div class="successFont">提交成功</div>
        <div class="tips">{{ submitSuccess ?  '您已提交过该问卷，感谢您的参与' : '非常感谢您的参与，问卷已成功提交' }}</div>
        <div class="closeBtn" @click="closeToast">关闭</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasPath: '',
      showPopup: false,
      showToast: false,
      title: '',
      questionList: [],
      isSubmit: false,
      isApiSubmit: false,
      submitSuccess: false
    }
  },
  props: {
    questionId: [Number, String],
    correlationId: Number,
    showType: {
      type: Number,
      default: 1 // 1.页面 2.弹出
    },
    pageType: Number,
    sourceType: [Number, String],
    sourceId: [Number, String]
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if(from.path == '/') {
        vm.hasPath = from.path;
      }
    });
  },
  created() {
    this.getQuestionnaire();
    this.getUserQuestion();
    this.tracking(this.showType, this.pageType, this.correlationId, this.sourceType, this.sourceId);
  },
  methods: {
    tracking(VisitType, Type, TieUpId , Source, SourceId) {
      this.$axios.post('/Api/Api/Web/Question/BPQ', {
        QId: this.questionId,
        Type: Type ? Type : '',
        VisitType: VisitType ? VisitType : '',
        TieUpId: TieUpId ? TieUpId : '',
        Source: Source ? Source : '',
        SourceId: SourceId ? SourceId : ''
      }).then(res => {})
    },
    getUserQuestion() {
      this.$axios.post('/Api/Api/Web/Question/GUQ', {
        QId: this.questionId
      }).then(res => {
        let data = res.Data;
        if(data) {
          this.submitSuccess = true;
          this.showToast = true;
        }
      })
    },
    getQuestionnaire() {
      this.$axios.post('/Api/Api/Web/Question/GetQ', {
        QId: this.questionId
      }).then(res => {
        let data = res.Data;
        this.title = data.Title;
        this.questionList = data.qtLst;
        this.questionList.forEach(item => {
          item.selectId = [];
          item.answer = '';
        })
        this.showPopup = true;
      })
    },
    selectOption(index, type, id) {
      if(type == 1) {
        this.questionList[index].selectId = [id];
      } else {
        let findIndex = this.questionList[index].selectId.indexOf(id);
        if(findIndex !== -1) {
          this.questionList[index].selectId.splice(findIndex, 1);
        } else {
          this.questionList[index].selectId.push(id);
        }
      }
      this.$forceUpdate();
    },
    updateAnswer(index, value) {
      this.$set(this.questionList[index], 'answer', value);
      this.$forceUpdate();
    },
    closeQuestion() {
      this.isSubmit = false;
      this.showPopup = false;
      this.$axios.post('/Api/Api/Web/Customer/AddUserIsFollow', {
        type: 4,
        sfId: this.questionId
      }).then(res => {
        this.tracking(4, this.pageType, this.correlationId);
      })
    },
    submit() {
      if(this.submitSuccess) {
        this.showToast = true;
        return;
      }

      this.isSubmit = true;
      let answeredList = [];
      let unansweredList = [];
      this.questionList.forEach(item => {
        answeredList.push({
          QTId: item.Id,
          QOId: item.selectId,
          Answer: item.answer
        })

        if((item.type != 3 && item.selectId.length == 0) || (item.type == 3 && item.answer == '')) {
          unansweredList.push(item.Id);
        }
      })

      if(unansweredList.length == 0 && !this.isApiSubmit) {
        this.isApiSubmit = true;
        if(this.showType == 1) {
          this.toastLoading = this.$toast.loading({
            message: '提交中...',
            forbidClick: true,
          });
        }
        this.$axios.post("/Api/Api/Web/Question/QSave", {
          QId: this.questionId,
          qts: answeredList
        }).then(res => {
          this.isApiSubmit = false;
          this.showPopup = false;
          if(this.showType == 1) {
            this.toastLoading.clear();
            this.showToast = true;
          }
          this.tracking(3, this.pageType, this.correlationId, this.sourceType);
        });
        this.showPopup = false;
      } else {
        const targetEl  = this.$refs['questionRef_' + unansweredList[0]];
        targetEl[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    questionnairePopupClosed() {
      if(this.isSubmit) {
        this.showToast = true;
      }
    },
    closeToast() {
      this.showToast = false;
      this.submitSuccess = true;
    },
    goback() {
      if(this.hasPath == '/' ) {
        this.$router.push('/home');
        return;
      }
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
}
.questionnaireBox {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #FFEDEB;
  .questionnaireTitle {
    display: flex;
    align-items: center;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    font-size: 15px;
    font-weight: bold;
    color: #000000;
    .arrow-left {
      display: block;
      width: 18px;
      margin-right: 10px;
    }
    .title {
      flex: 1;
    }
    .close {
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 20px;
      background: rgba( 255, 255, 255, 0.8);
      color: #EB1700;
      margin-left: 10px;
    }
  }
  .questionnaireContent {
    flex: 1;
    background-color: #FFFFFF;
    border-radius: 12px 12px 0 0;
    padding: 15px;
    box-sizing: border-box;
    overflow: auto;
    .questionnaireItem {
      margin-bottom: 20px;
      .question {
        position: relative;
        display: flex;
        .questionText {
          font-size: 14px;
          color: 333333;
          font-weight: bold;
          margin-left: 16px;
        }
        .questionType {
          position: absolute;
          left: -15px;
          top: 3px;
          width: 26px;
          height: 16px;
          line-height: 16px;
          text-align: center;
          background-color: #EB1700;
          color: #FFFFFF;
          font-size: 9px;
          border-radius: 0 18px 18px 0;
        }
      }
      .questionOptions {
        .option {
          padding: 10px;
          font-size: 14px;
          color: #000000;
          background-color: #F9F9F9;
          border-radius: 10px;
          margin-top: 12px;
        }
        .active {
          font-weight: bold;
          background-color: #FFEDEB;
        }
      }
      .textarea {
        border: 1px solid #D8D8D8;
        border-radius: 12px;
        overflow: hidden;
        margin-top: 12px;
      }
      .tips {
        font-size: 12px;
        color: #EB1700;
        margin-top: 5px;
        .icon {
          position: relative;
          top: 1px;
          font-size: 14px;
          margin-right: 2px;
        }
      }
    }
    .submit {
      height: 36px;
      line-height: 36px;
      border-radius: 36px;
      background-color: #EB1700;
      font-size: 14px;
      font-weight: bold;
      color: #FFFFFF;
      text-align: center;
    }
  }
}

.toastPopup {
  width: 80%;
  .toastBox {
    text-align: center;
    padding: 30px;
    background-color: #FFFFFF;
    border-radius: 4px;
    .successIcon {
      display: block;
      width: 60px;
      border-radius: 50%;
      margin: 10px auto;
      box-shadow: 0 0 30px 0 rgba(235, 23, 0, 0.3);
    }
    .successFont {
      font-size: 20px;
      font-weight: bold;
      color: #EB1700;
    }
    .tips {
      font-size: 12px;
      color: #3D3D3D;
      margin-top: 5px;
    }
    .closeBtn {
      height: 34px;
      line-height: 34px;
      border-radius: 34px;
      background-color: #EB1700;
      font-size: 14px;
      color: #FFFFFF;
      margin-top: 30px;
    }
  }
}
</style>
